import type { BrandId } from './types';

/** Thrown when an installation or a build does not state a known brand. */
export class BrandNotConfiguredError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BrandNotConfiguredError';
  }
}

/** Where each surface states its brand, in order of precedence. */
export const BRAND_ENV_KEYS = ['BRAND_ID', 'NEXT_PUBLIC_BRAND_ID', 'VITE_BRAND_ID', 'APP_VARIANT'] as const;

/**
 * The brand an environment states. There is deliberately no default: a
 * forgotten variable must stop the start or the build, never turn one
 * installation into the other.
 */
export function resolveBrandId(env: Record<string, string | undefined>, known: readonly BrandId[]): BrandId {
  const stated = BRAND_ENV_KEYS.map((key) => env[key]?.trim().toLowerCase()).find((value) => !!value);
  if (!stated) {
    throw new BrandNotConfiguredError(`no brand stated: set one of ${BRAND_ENV_KEYS.join(', ')}`);
  }
  if (!known.includes(stated)) {
    throw new BrandNotConfiguredError(`unknown brand "${stated}" (known: ${known.join(', ')})`);
  }
  return stated;
}
